import { useMutation, useQueryClient } from 'react-query';

import { RequestStatus } from 'components/detailsModal/models';

import { QueryKey } from '../models';

type ChangeCorporateOfferStatus = {
  corporateOfferId: string;
};

const useChangeOfferStatus = (
  setTitle: (title: string) => void,
  setStatus: (status: RequestStatus) => void,
  mutationFn: ({
    corporateOfferId,
  }: ChangeCorporateOfferStatus) => Promise<unknown>
) => {
  const queryClient = useQueryClient();

  return useMutation(mutationFn, {
    onSuccess: () => {
      setStatus(RequestStatus.Success);
      queryClient.invalidateQueries(QueryKey.GetCorporateOffers);
    },
    onError: (error: Error) => {
      setStatus(RequestStatus.Fail);
      setTitle('Something went wrong :(');
      console.error(error.message);
    },
  });
};

export default useChangeOfferStatus;
